exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._3vVsNeiTtqCxSsBhJWqL7{margin-top:5px;margin-bottom:5px;border-bottom:1px solid \"[theme:neutralLight, default:#edebe9]\"}html[dir=ltr] ._3vVsNeiTtqCxSsBhJWqL7{padding-left:44px}html[dir=rtl] ._3vVsNeiTtqCxSsBhJWqL7{padding-right:44px}", ""]);
// Exports
exports.locals = {
	"rootContainer": "_3vVsNeiTtqCxSsBhJWqL7"
};